import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useGlobalContext } from "../context/globalContext";
import PropTypes from 'prop-types';
import logo from "../assets/favicon.png";
import brand from "../assets/sarrthiias-logo.png";

function Navbar() {
    const [expanded, setExpanded] = useState(true);
    const location = useLocation();
    const { userInfo } = useGlobalContext();
    const allowedEmails = ['shantanuesakpal1420@gmail.com'];

    const menuItems = [
        { icon: "fa-solid fa-home", text: "Home", link: "/" },
        { icon: "fa-solid fa-check-circle", text: "Resolved", link: "/resolved" },
        { icon: "fa-solid fa-exclamation-circle", text: "Unresolved", link: "/unresolved" },
        ...(userInfo?.isAdmin ? [
            { icon: "fa-solid fa-chart-bar", text: "Stats", link: "/stats" },
            { icon: "fa-solid fa-tachometer-alt", text: "Dashboard", link: "/dashboard" },
            { icon: "fa-solid fa-phone", text: "Call Score", link: "/call-score" },
            { icon: "fa-solid fa-clock-rotate-left", text: "Monthly user's history", link: "/monthly-user-history" },
            { icon: "fa-solid fa-calendar", text: "Current Month Stats", link: "/current-users-stats" },
            { icon: "fa-solid fa-credit-card", text: "UPI Payment Query", link: "/upipayment" },
            { icon: "fa-solid fa-users", text: "User Management", link: "/user-management" },
            { icon: "fa-solid fa-graduation-cap", text: "Course Management", link: "/course-management" }
        ] : [
            { icon: "fa-solid fa-phone", text: "Call Score", link: "/call-score" },
            { icon: "fa-solid fa-user", text: "Profile", link: "/profile" },
            { icon: "fa-solid fa-clock-rotate-left", text: "History", link: "/history" }
        ]),
        ...(allowedEmails.includes(userInfo?.email) ? [
            { icon: "fa fa-gift", text: "Incentives", link: "/incentives" }
        ] : []),
        { icon: "fa-solid fa-trophy", text: "Top Performers", link: "/topperformers" },
        { icon: "fa-solid fa-bullhorn", text: "Announcements", link: "/announcements" },
        { icon: "fa-solid fa-robot", text: "Chatbot", link: "/chatbot" },
        { icon: "fa-solid fa-book", text: "Mentorship", link: "/mentorship" }
    ];

    return (
        <aside className="h-screen w-fit">
            <nav className="h-full flex flex-col bg-white border-r shadow-sm">
                <div className="p-4 pb-2 flex justify-between items-center mb-5">
                    <div className="w-full flex justify-center items-center">
                        <img
                            className={`overflow-hidden transition-all ${expanded ? "w-20" : "w-10"}`}
                            src={expanded ? brand : logo}
                            alt="Logo"
                        />
                    </div>
                    <button
                        onClick={() => setExpanded((curr) => !curr)}
                        className="p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100"
                    >
                        {expanded ? (
                            <i className="fa-solid fa-chevron-left"></i>
                        ) : (
                            <i className="fa-solid fa-chevron-right"></i>
                        )}
                    </button>
                </div>

                <ul className="flex-1 px-3 overflow-y-auto max-h-[calc(100vh-130px)] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                    {menuItems.map(({ icon, text, link }) => (
                        <SidebarItem
                            key={link}
                            expanded={expanded}
                            icon={icon}
                            text={text}
                            active={location.pathname === link}
                            link={link}
                        />
                    ))}
                </ul>

                <div className="border-t p-3">
                    <Link
                        to="/"
                        className="flex items-center justify-center py-2 px-3 rounded-md hover:bg-blue-50 text-gray-600"
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                        {expanded && <span className="ml-2">Back to Main</span>}
                    </Link>
                </div>
            </nav>
        </aside>
    );
}

function SidebarItem({ icon, text, active, link, expanded }) {
    return (
        <Link
            to={link}
            className={`
                relative flex items-center ${expanded ? "" : "justify-center"} py-2 px-3 my-1
                font-medium rounded-md cursor-pointer
                transition-colors group h-10
                ${
                    active
                        ? "bg-gradient-to-tr from-indigo-200 to-indigo-100 text-indigo-800"
                        : "hover:bg-indigo-50 text-gray-600"
                }
            `}
        >
            <i className={`${icon} w-5`}></i>
            {expanded && <span className="ml-2">{text}</span>}
        </Link>
    );
}

SidebarItem.propTypes = {
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired
};

export default Navbar;